"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tooltip_1 = require("../../parts/Tooltip");
var utils_1 = require("../../../utils");
function default_1(area, chartTooltip, initialRun) {
    var _a = area.props, showTooltips = _a.showTooltips, children = _a.children, onHide = _a.onHide, onShow = _a.onShow, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClick = _a.onClick, onPointClick = _a.onPointClick, onPointMouseEnter = _a.onPointMouseEnter, onPointMouseLeave = _a.onPointMouseLeave, overrides = __rest(_a, ["showTooltips", "children", "onHide", "onShow", "onMouseEnter", "onMouseLeave", "onClick", "onPointClick", "onPointMouseEnter", "onPointMouseLeave"]);
    var seriesTooltip = utils_1.typeChildren(children).tooltip;
    var tooltip = seriesTooltip || chartTooltip;
    var options = __assign({}, overrides);
    options.tooltip = Tooltip_1.tooltipOptions({ showTooltips: showTooltips }, tooltip);
    if (initialRun) {
        options.events = utils_1.bindEventHandlers({ onClick: onClick, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, onShow: onShow, onHide: onHide });
        options.point = utils_1.bindPointEventHandlers({ onPointClick: onPointClick, onPointMouseEnter: onPointMouseEnter, onPointMouseLeave: onPointMouseLeave });
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=candleStickOptions.js.map